<template>
  <VListItem
    ref="theNavigationMenuItem"
    class="text-decoration-none"
    v-bind="attrs"
    :data-testid="`theNavigationMenuItem_${camelCase(navItem.title)}`"
    role="listitem"
    @click="navItem.action"
  >
    <template
      v-if="navItem.prependIcon"
      #prepend
    >
      <VIcon :icon="navItem.prependIcon" />
    </template>
    <template
      v-if="isExpanded && navItem.badge"
      #append
    >
      <VBadge
        color="white"
        :content="navItem.badge"
        inline
      />
    </template>
    <VTooltip
      v-if="!isExpanded && tooltipVisible"
      ref="theNavigationMenuItemTooltip"
      activator="parent"
      location="right"
      :aria-label="navItem.title"
    >
      {{ navItem.title }}
    </VTooltip>
  </VListItem>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { camelCase } from 'lodash-es';
import type { PrimaryNavigationItem } from '@/composables/usePrimaryNavigation';


const {
  navItem,
  isExpanded = true,
  tooltipVisible = true,
} = defineProps<{
  navItem: PrimaryNavigationItem;
  isExpanded: boolean;
  tooltipVisible?: boolean;
}>();


const attrs = computed(() => {
  const attrs = {
    title: navItem.title,
    appendIcon: navItem.appendIcon,
    disabled: !navItem.enabled,
  };

  if (navItem.to) {
    Object.assign(attrs, {
      to: navItem.to,
    });
  }

  if (navItem.link) {
    Object.assign(attrs, {
      href: navItem.link,
      target: '_blank',
      appendIcon: 'open_in_new',
    });
  }

  return attrs;
});

</script>
